// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"bd7edd74","73":"5622d076","309":"a07b4ad2","417":"4bf77ab0","431":"300f2d79","450":"3ff97b32","453":"8bd102f6","521":"fdceadd4","677":"316730c0","838":"aed5691d","885":"a5dc1713","951":"cf075ef7","993":"5b42d021"}[chunkId] + ".chunk.js";
};